import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["type", "disabled"];
const _hoisted_2 = { class: "rc-loader" };
import { vTooltip } from "@/common/directives/tip-directive";
import { defineAsyncComponent } from "vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'SaveButton',
    props: {
        saving: { type: Boolean },
        disabled: { type: Boolean },
        tooltip: { default: "" },
        type: { default: "button" }
    },
    setup(__props) {
        const SvgIcon = defineAsyncComponent(() => import("./SvgIcon.vue"));
        // Types & Enums
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["btn btn-primary btn-loader", { 'rc-loading': _ctx.saving, 'rc-disabled': _ctx.disabled || _ctx.saving }]),
                type: _ctx.type,
                disabled: _ctx.disabled || _ctx.saving
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(SvgIcon), { icon: "loader-spin" })
                ]),
                _renderSlot(_ctx.$slots, "default")
            ], 10, _hoisted_1)), [
                [_unref(vTooltip), _ctx.tooltip]
            ]);
        };
    }
});
